import { FC } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { CollectionName } from '@/shared/lib/sj-orm/types';

import { ItemBaseDto, UpdateCollectionsModalCollectionItem } from '../../types';

import { useColumns } from './useColumns';

type TableProps = {
  collectionName: CollectionName;
  items: UpdateCollectionsModalCollectionItem[];
  onSelect: (item: UpdateCollectionsModalCollectionItem) => void;
  filledItems: Record<string, ItemBaseDto>;
};

export const Table: FC<TableProps> = ({ collectionName, items, onSelect, filledItems }) => {
  const columns = useColumns({ collectionName, filledItems });

  return (
    <TableContainer>
      <thead>
        <Tr>
          {columns.map((item, index) => (
            <Th style={item.style} key={index}>
              {item.title}
            </Th>
          ))}
        </Tr>
      </thead>
      <tbody>
        {items?.map((iItem, indexRow) => (
          <Tr onClick={() => onSelect(iItem)} key={indexRow}>
            {columns.map((item, indexCell) => (
              <Td style={item.style} key={indexCell}>
                {item.render(iItem)}
              </Td>
            ))}
          </Tr>
        ))}
      </tbody>
    </TableContainer>
  );
};

const TableContainer = styled.table`
  table-layout: fixed;
  width: 100%;
  border-spacing: 0px;
  border-collapse: separate;
`;

const Tr = styled.tr`
  tbody &&&:hover {
    background: ${COLORS.systemLight200};
  }
`;

const Th = styled.th`
  padding-left: 12px;
  height: 52px;
  border-bottom: 1px solid ${COLORS.systemDark100};
  text-align: left;
`;

const Td = styled.td`
  height: 52px;
  border-bottom: 1px solid ${COLORS.systemDark100};
  cursor: pointer;
  text-overflow: ellipsis;
`;
